export const getBooleanLabel = (value?: boolean | string): string => {
  if (value !== null && value !== undefined)
    return value === true || value === 'true' ? $localize`Oui` : $localize`Non`;
  return '';
};

export const compareArrays = (
  arr1: unknown[],
  arr2: unknown[],
  comparator = (a: any, b: any) => a === b
): boolean => {
  if (arr1 !== arr2 || arr1?.length !== arr2?.length) {
    return false;
  }

  return arr1.every((element, index) => comparator(element, arr2[index]));
};
